const SHARED_PASSWORD_ENDPOINT = process.env.REACT_APP_SHARED_PASSWORD_ENDPOINT
const CUSTOM_LOGIN_SERVICES = process.env.REACT_APP_CUSTOM_LOGIN_ENDPOINT
const STATIC_PRIMARY_BUCKET = process.env.REACT_APP_STATIC_CONTENT_PRIMRY_BUCKET
const STATIC_SECONDARY_BUCKET =
  process.env.REACT_APP_STATIC_CONTENT_SECONDARY_BUCKET
const apiConfig: any = {
  /**
   * Log user's login details in S3 for shared password report analysis
   */
  logUserDetails: () => `${SHARED_PASSWORD_ENDPOINT}/custom-logs`,

  /**
   * Logs error in Cloud Watch
   */
  logError: () => `${CUSTOM_LOGIN_SERVICES}/log-error`,

  /**
   * Update user's agreement acceptance date and
   * move to group 'Active Members - TOU Accepted'
   */
  updateUserAgreementAcceptance: () =>
    `${CUSTOM_LOGIN_SERVICES}/update-user-agreement-acceptance`,

  /**
   * Recover username from Okta
   */
  recoverUsername: (email: string) =>
    `${CUSTOM_LOGIN_SERVICES}/recover-username?email=${email}`,

  /**
   * After resetting user's password in Okta also reset in Forgerock
   */
  resetForgerockPassword: () =>
    `${CUSTOM_LOGIN_SERVICES}/reset-forgerock-password`,

  /**
   * Get Password Policy from Okta
   */
  getPasswordPolicy: () => `${CUSTOM_LOGIN_SERVICES}/password-policy`,

  /**
   * Change password in Okta
   */
  changePassword: () => `${CUSTOM_LOGIN_SERVICES}/change-password`,

  /**
   * After resetting user's password in Okta we save it encrypted in DynamoDb table in case we need to switch from Okta to something else and transfer the passwords
   */
  savePassword: () => `${CUSTOM_LOGIN_SERVICES}/save-password`,

  /**
   * Get unmasked phone number  */
  getPhoneNumber: () => `${CUSTOM_LOGIN_SERVICES}/factordetails`,

  /**
   * Update sms factor mobile number enroll and activate  */
  updateFactorDetails: () => `${CUSTOM_LOGIN_SERVICES}/update-sms-factor`,

  /**
   * Get login article   */
  loginArticle: () =>
    `https://${STATIC_PRIMARY_BUCKET}.s3.amazonaws.com/Unauthenticated/ssoLogin.json`,

  /**
   * Get login article   */
  mfaArticle: () =>
    `https://${STATIC_PRIMARY_BUCKET}.s3.amazonaws.com/Unauthenticated/ssoMfa.json`,

  /**
   * Get login article from secondary bucket   */
  loginArticleSecondary: () =>
    `https://${STATIC_SECONDARY_BUCKET}.s3.amazonaws.com/Unauthenticated/ssoLogin.json`,

  /**
   * Get subscription agreement   */
  subscriptionAgreement: () =>
    `https://${STATIC_PRIMARY_BUCKET}.s3.amazonaws.com/Unauthenticated/subscription-agreement.json`,

  /**
   * Get subscription agreement from secondary bucket   */
  subscriptionAgreementSecondary: () =>
    `https://${STATIC_SECONDARY_BUCKET}.s3.amazonaws.com/Unauthenticated/subscription-agreement.json`,
}

export default apiConfig
